import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-infolinia-modal',
  templateUrl: './infolinia-modal.component.html',
  styleUrls: ['./infolinia-modal.component.scss'],
})
export class InfoliniaModalComponent implements OnInit {
  public business = false;

  constructor(
    public readonly authService: AuthService,
    public ngxSmartModalService: NgxSmartModalService
  ) {}

  ngOnInit(): void {
    window.location.href.indexOf('biznes') > -1
      ? (this.business = true)
      : (this.business = false);
    console.warn(
      'URL',
      window.location.href,
      window.location.href.indexOf('biznes')
    );
  }

  closeModal() {
    this.ngxSmartModalService.getModal('infolinia').close();
  }
}
